import React from 'react';
import { Input, Form } from 'antd';
import styled from 'styled-components';
import { textInputValueWithoutEmoji } from '_src/utils';

const { TextArea } = Input;

const Label = styled.label`
  margin-bottom: 5px;
  color: ${({ hasError }) => (hasError ? '#f5222d' : '')};
`;

export default ({ error, touched, label, onChange, name = '', dataCy = '', ...rest }) => {
  const hasError = error && touched;
  const textareaId = rest.id || name || undefined;

  return (
    <Form.Item validateStatus={hasError ? 'error' : ''}>
      {(label || hasError) && (
        <Label htmlFor={textareaId} hasError={hasError}>
          {hasError ? error : label}
        </Label>
      )}
      <TextArea
        {...rest}
        id={textareaId}
        name={name}
        aria-label={label || rest.placeholder || name || undefined}
        aria-invalid={Boolean(hasError)}
        onChange={e => onChange && onChange(textInputValueWithoutEmoji(e.target.value))}
        data-cy={dataCy || 'field-textarea-' + name}
      />
    </Form.Item>
  );
};
